import { render } from "./IconPlay.vue?vue&type=template&id=a1707a3a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1707a3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1707a3a', __exports__)) {
    api.reload('a1707a3a', __exports__)
  }
  
  module.hot.accept("./IconPlay.vue?vue&type=template&id=a1707a3a", () => {
    api.rerender('a1707a3a', render)
  })

}


export default __exports__